import { FormattedArticle } from 'types/AlgoliaResults';
import { SearchResultCard, getCMSImages } from '..';
import { StringService } from 'service/string/stringService';
import { PathSegment, PathTranslations } from 'service/localization/getPathTranslations';

export const mapAlogliaArticleToSearchCard = (
  article: FormattedArticle,
  labels: Record<string, string>,
  pathTranslations: PathTranslations,
): SearchResultCard => {
  let slug;
  if (article.type) {
    if (article.type === 'generic' || article.type === 'Generic') {
      slug = `${pathTranslations?.genericPage}${article.slug}`;
    } else {
      slug = `${pathTranslations[StringService.lowerCaseFirstLetter(article.type) as PathSegment]}${
        article.slug
      }`;
    }
  } else {
    slug = `${pathTranslations?.genericPage}${article.slug}`;
  }
  return {
    resultType: 'article',
    id: article.objectID,
    title: article.title,
    description: article.description,
    images: getCMSImages(article.images),
    link: {
      url: slug,
      displayName: labels.see_details || 'See details',
    },
  };
};
